<div class="layout-topbar">
  <div class="layout-topbar-logo-container">
    <div class="block 2xl:hidden">
      <button class="layout-menu-button layout-topbar-action" (click)="toggleMobileMenu()">
        <i class="pi pi-bars"></i>
      </button>
    </div>
    <img src="assets/images/logo.svg" alt="logo" />
  </div>

  <div class="layout-topbar-actions">
    <div class="layout-config-menu">
      <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
        <i [ngClass]="{
            'pi ': true,
            'pi-moon': layoutService.isDarkTheme(),
            'pi-sun': !layoutService.isDarkTheme(),
          }"></i>
      </button>
      <div class="hidden">
        <button class="layout-topbar-action layout-topbar-action-highlight" pStyleClass="@next" enterFromClass="hidden"
          enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true">
          <i class="pi pi-palette"></i>
        </button>
        <sm-layout-configurator />
      </div>
    </div>

    <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden"
      enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout"
      [hideOnOutsideClick]="true">
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <div class="layout-topbar-menu hidden lg:block">
      <div class="layout-topbar-menu-content">
        <sm-language-switcher />
        <div class="layout-topbar-user-info">
          <span class="layout-topbar-user-name" *ngIf="fullName">{{ fullName }}</span>
          <button type="button" class="layout-topbar-action" routerLink="/profile">
            <i class="pi pi-user"></i>
            <span>Profile</span>
          </button>
        </div>
          <sm-notification />
          <button type="button" class="layout-topbar-action" (click)="logout()">
            <i class="pi pi-sign-out"></i>
          </button>
      </div>
    </div>
  </div>
</div>